import { render, staticRenderFns } from "./SocialPreview.vue?vue&type=template&id=94e0e762&scoped=true&"
import script from "./SocialPreview.vue?vue&type=script&lang=ts&"
export * from "./SocialPreview.vue?vue&type=script&lang=ts&"
import style0 from "./SocialPreview.vue?vue&type=style&index=0&id=94e0e762&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e0e762",
  null
  
)

export default component.exports